module.exports = __webpack_public_path__ + "img/logo.6a30156b.png";